/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const fortune_ball_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M4.34 18.5a8.09 8.09 0 0 1-2.178-4.103 8.24 8.24 0 0 1 .415-4.656 7.977 7.977 0 0 1 2.867-3.626A7.635 7.635 0 0 1 9.788 4.75c1.548 0 3.06.473 4.346 1.36a7.976 7.976 0 0 1 2.87 3.624 8.238 8.238 0 0 1 .419 4.656 8.09 8.09 0 0 1-2.174 4.105M20.791 7.5v2.75m-1.375-1.375h2.75M3.375 2v2.75M2 3.375h2.75m5.958 4.208v2.75M9.333 8.958h2.75M16.208 2v2.75m-1.375-1.375h2.75M15.396 18.5H4.185l-1.08 1.767a1.314 1.314 0 0 0-.056 1.253c.095.195.237.358.411.472.174.114.373.174.575.175h11.51c.204 0 .403-.06.577-.174.174-.114.316-.277.412-.472a1.314 1.314 0 0 0-.056-1.255L15.396 18.5Z"
    />
  </svg>
)
export default fortune_ball_medium
